import React from "react";
import { Typography } from "@mui/material";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
} from "./MonthlyReport.styles";
import { PriceCheck } from "@mui/icons-material";
import { formatNumber, formatPercentage } from "./MonthlyReport.utils";

const MonthlyReportCommissionConfig = ({ commission_config, userType }) => {
  if (!commission_config) return null;

  // Merchant uses different field names
  const isMerchant = userType === "merchant";

  return (
    <GridItem xs={12} padding="0 0 15px 0">
      <DataCard>
        <DataCardHeader>
          <PriceCheck color="primary" />
          <DataCardTitle>Commission Configuration</DataCardTitle>
        </DataCardHeader>
        <GridContainer spacing={2} style={{ marginTop: "16px" }}>
          {isMerchant ? (
            <>
              <GridItem xs={12} sm={6} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Merchant Discount Rate
                </Typography>
                <Typography variant="body1">
                  {formatPercentage(commission_config.percent_tx_processing) || "0.0000"}%
                </Typography>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Processing Fee
                </Typography>
                <Typography variant="body1">
                  ${formatNumber(commission_config.amount_tx_processing) || "0.00"}
                </Typography>
              </GridItem>
              {
                !['0', '0.00', 0, null].includes(commission_config.amount_terminal_maintenance) && (
                  <GridItem xs={12} sm={6} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Terminal Maintenance
                    </Typography>
                    <Typography variant="body1">
                      ${formatNumber(commission_config.amount_terminal_maintenance) || "0.00"}
                    </Typography>
                  </GridItem>
                )
              }
              {
                !['0', '0.00', 0, null].includes(commission_config.amount_terminal_setup) && (
                  <GridItem xs={12} sm={6} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Terminal Setup
                    </Typography>
                    <Typography variant="body1">
                      ${formatNumber(commission_config.amount_terminal_setup) || "0.00"}
                    </Typography>
                  </GridItem>
                )
              }
            </>
          ) : (
            <>
              <GridItem xs={12} sm={6} md={4}>
                <Typography variant="body2" color="text.secondary">
                    Merchant Discount Rate
                </Typography>
                <Typography variant="body1">
                  {formatPercentage(commission_config.percent_tx_processing) || "0.0000"}%
                </Typography>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Typography variant="body2" color="text.secondary">
                  Processing Fee
                </Typography>
                <Typography variant="body1">
                  ${formatNumber(commission_config.fiat_tx_processing) || "0.00"}
                </Typography>
              </GridItem>
              {!['0', '0.00', 0, null].includes(commission_config.monthly_amount_peer_mid) && ( 
                <GridItem xs={12} sm={6} md={4}>
                  <Typography variant="body2" color="text.secondary">
                    Monthly MID Fee
                  </Typography>
                  <Typography variant="body1">
                    ${formatNumber(commission_config.monthly_amount_peer_mid) || "0.00"}
                  </Typography>
                </GridItem>
              )}
              {
                !['0', '0.00', 0, null].includes(commission_config.fiat_terminal_maintenance) && (
                  <GridItem xs={12} sm={6} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Terminal Maintenance
                    </Typography>
                    <Typography variant="body1">
                      ${formatNumber(commission_config.fiat_terminal_maintenance) || "0.00"}
                    </Typography>
                  </GridItem>
                )
              }
              {
                !['0', '0.00', 0, null].includes(commission_config.fiat_terminal_setup) && (
                  <GridItem xs={12} sm={6} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Terminal Setup
                    </Typography>
                    <Typography variant="body1">
                      ${formatNumber(commission_config.fiat_terminal_setup) || "0.00"}
                    </Typography>
                  </GridItem>
                )
              }
            </>
          )}
        </GridContainer>
      </DataCard>
    </GridItem>
  );
};

export default MonthlyReportCommissionConfig;

